export const KEY_CODE_KEYBOARD_ENTER = 13 as const;
export const KEY_CODE_KEYBOARD_ESC = 27 as const;
export const KEY_CODE_KEYBOARD_UP = 38 as const;
export const KEY_CODE_KEYBOARD_DOWN = 40 as const;
export const KEY_CODE_KEYBOARD_LEFT = 37 as const;
export const KEY_CODE_KEYBOARD_RIGHT = 39 as const;
